module.exports = __webpack_public_path__ + "static/media/tm6_4.8b7532ad.svg";